import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#05080D] text-white grid lg:grid-cols-2">
      {/* Left panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-white/8 overflow-hidden vora-hero-radial">
        <div className="absolute inset-0 vora-grid-bg opacity-40" aria-hidden />
        <div className="relative">
          <Logo to="/" />
        </div>
        <div className="relative max-w-md">
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#8fb4ff]">Custom AI Agents for Real Work</p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-tight">
            Custom AI agents that get real work done.
          </h2>
          <p className="mt-4 text-slate-400">
            We design and deploy AI agents around your needs — automating workflows, assisting your team and reducing repetitive work.
          </p>
        </div>
        <p className="relative text-xs text-slate-500">© 2026 Vvvoraa</p>
      </div>

      {/* Right panel */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8">
            <Logo to="/" />
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-2 text-sm text-slate-400">{subtitle}</p>
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-400">{footer}</div>}
          <p className="mt-10 text-center text-xs text-slate-600">
            <Link to="/" className="hover:text-slate-400">← Back to Vvvoraa</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
